<script>
    import GoogleMap from "./GoogleMap.svelte";
    import Privacy from "../Privacy.svelte";
    import {navigate} from "svelte-routing";
</script>

<div class="flex-center">
    <span class="font-size-22">Informazione</span>
    <div class="margin-top-20  main-div">
        <div>
            <div style="display:flex; font-weight: bold; margin-bottom: 10px;">
                <img class="icon" src="./icons/home.png" alt="home">
                <span style="margin-left:10px;">Adriana Brows</span>
            </div>
            <a style="margin-top:30px;" href="https://maps.app.goo.gl/UAexsKBzesWfRYfQ9">Via dei Papafava 7, Padova, Italia</a>
        </div>
        <div class="orar">
            <div class="flex-column">
                <span>Lunedì</span>
                <span>Martedì</span>
                <span>Mercoledì</span>
                <span>Giovedì</span>
                <span>Venerdì</span>
                <span>Sabato</span>
                <span>Domenica</span>
            </div>
            <div class="flex-column">
                <span>Su appuntamento</span>
                <span>Su appuntamento</span>
                <span>Su appuntamento</span>
                <span>Su appuntamento</span>
                <span>Su appuntamento</span>
                <span style="text-align: center;">Su appuntamento</span>
                <span style="text-align: center;">Chiuso</span>
            </div>
        </div>
    </div>

    <div class="margin-top-20  main-div">
        <div>
            <div style="font-weight: bold; margin-bottom: 10px;">
                <span>Contatti</span>
            </div>
            <div class="orar">
                <div style="display:flex; align-items:center;">
                    <img class="icon" src="./icons/phone-call.png" alt="home">
                    <span style="margin-left:10px;">Telefono:</span>
                    <a style="margin-left:10px;" href="tel:+39 329 741 9984">+39 329 741 9984</a>
                </div>
            </div>
            <div class="orar">
                <div style="display:flex; align-items:center;">
                    <img class="icon" src="./icons/instagram.png" alt="home">
                    <span style="margin-left:10px;">Instagram:</span>
                    <a style="margin-left:10px;" href="https://www.instagram.com/adrianabrows_?igsh=MTVobWRvZDF4aW02Yg%3D%3D">adrianabrows_</a>
                </div>
            </div>
        </div>
    </div>
    <div class="margin-top-20  main-div">
        <GoogleMap />
    </div>
    <span class="privacy" on:click={() => navigate("/privacy")}>PRIVACY E COOKIE</span>
</div>

<style>
    .privacy{
        text-align: center;
        margin-top:50px;
        padding-bottom:50px;
        font-size:20px;
        font-weight:bold;
        cursor: pointer;
    }
    .flex-column{
        display: flex;
        flex-direction: column;
    }
    .orar{
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
    }
    .main-div{
        padding: 20px;
        width: 80%;
        border-radius: 10px;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    }
    .flex-center {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        max-height: calc(100dvh - 53px - 230px);
    }
    .font-size-22 {
        font-size: 22px;
        font-weight: bold;
    }
    .margin-top-20{
        margin-top: 20px;
    }
    .icon{
        width: 20px;
        height: 20px;
    }
    @media (max-width: 768px) {
        .flex-center {
            width: 100vw;
        }
    }
</style>